<ion-card>

  <ion-card-content>

    <div class="button-group">

      <ion-button (click)="preload(true)">Preload In</ion-button>
      <ion-button (click)="preload(false)">Preload Out</ion-button>
    </div>

    <div class="button-group">
      <ion-button (click)="triggerIn()" [disabled]="!canTrigger">Trigger In</ion-button>
      <ion-button (click)="triggerRelease()" [disabled]="canTrigger">Trigger Release</ion-button>
    </div>

    <div class="button-group">
      <ion-button (click)="doubleTrigger()">Double Trigger</ion-button>
    </div>


    <div class="button-group">
      <ion-button (click)="setLevel(1)">Level Up</ion-button>
      <ion-button (click)="setLevel(-1)">Level Down</ion-button>
    </div>

  </ion-card-content>
</ion-card>